var prevStartup = __webpack_require__.x;
var hasRun = false;
__webpack_require__.x = () => {
	if (!hasRun) {
	  hasRun = true;
	  __webpack_require__(/*! ./node_modules/.pnpm/@angular-devkit+build-angular@21.2.7_aa5ca2618e824b2d917a890fe474732e/node_modules/@angular-devkit/build-angular/src/tools/babel/webpack-loader.js??ruleSet[1].rules[2].use[0]!./node_modules/.pnpm/source-map-loader@5.0.0_webpack@5.105.2_@swc+core@1.15.8_@swc+helpers@0.5.21__esbuild@0.27.3_/node_modules/source-map-loader/dist/cjs.js??ruleSet[1].rules[3]!./node_modules/.federation/entry.89980d0cdd7bda4364c052597c09dbb1.js */ 37212);
	}
	if (typeof prevStartup === 'function') {
	  return prevStartup();
	} else {
	  console.warn('[Module Federation] prevStartup is not a function, skipping startup execution');
	}
};